import api from '@/api'

let project_status_map = {
  "icons": {
    1: "fa-edit",
    2: "fa-eye",
    3: "fa-eye",
    4: "fa-eye",
    5: "fa-exclamation-triangle",
    6: "fa-eye",
    7: "fa-eye",
    8: "fa-eye",
    9: "fa-eye",
    10: "fa-eye",
    11: "fa-check-circle",
    12: "fa-check-circle",
    13: "fa-times"
  },
  "colors": {
    1: "grey",
    2: "blue",
    3: "blue",
    4: "blue",
    5: "warning",
    6: "blue",
    7: "blue",
    8: "blue",
    9: "blue",
    10: "blue",
    11: "green",
    12: "green",
    13: "red"
  },
  "labels": {
    1: "Draft",
    2: "In Review",
    3: "In Review",
    4: "In Review",
    5: "Revision Required",
    6: "In Review",
    7: "In Review",
    8: "In Review",
    9: "In Review",
    10: "In Review",
    11: "Published",
    12: "Published",
    13: "Rejected"
  }
}


export default {
  namespaced: true,
  state: {
    projects: [],
    loaded_project: {},
    sort: 'Newest',
    sort_options: ['Newest', 'Oldest', 'Title'],
    filter: null,
    filter_options: ['Draft', 'In Review', 'Revision Required', 'Published', 'Rejected'],
    contest_only: false
  },
  getters: {
    published: function(state) {
      return state.projects.filter(p => {
        return p.status == 11 || p.status == 12
      })
    },
    statusColor: () => (project) => {
      return project_status_map.colors[project.status] || "primary"
    },
    statusLabel: () => (project) => {
      return project_status_map.labels[project.status] || "Unknown Status"
    },
    statusIcon: () => (project) => {
      return project_status_map.icons[project.status] || "fa-circle"
    },
    list(state, getters) {
      return state.projects.filter(project => {
        if (state.contest_only) {
          if (!project.contest_id) {
            return false
          }
        }
        if (!state.filter) {
          return true
        }
        return typeof state.filter === "object" ? state.filter.includes(getters.statusLabel(project)) : getters.statusLabel(project) === state.filter
      }).sort((a, b) => {

        if (state.sort === "Newest") {
          if (a.id < b.id) {
            return 1
          }
          if (a.id > b.id) {
            return -1
          }
        } else if (state.sort === "Oldest") {
          if (b.id > a.id) {
            return 1
          }
          if (b.id > a.id) {
            return -1
          }
        } else {
          return 0
        }
      })
    }
  },
  mutations: {
    projects_loaded(state, projects) {
      state.projects = projects
    },
    project_loaded(state, p) {
      state.loaded_project = p
    },
    update_sort(state, sort) {
      state.sort = sort;
    },
    update_filter(state, filter) {
      state.filter = filter
    }
  },
  actions: {
    async load(context) {
      let projects = await api({
        method: "GET",
        url: "/account/user/projects"
      })
      context.commit('projects_loaded', projects)
    },
    loadProject: async function(context, id) {
      id = parseInt(id)
      let project = context.state.projects.find(p => {
        return p.id === id
      })
      if (project) {
        context.commit('project_loaded', project)
      } else {
        //We dont have it in state yet so load it from the database
        //project = await http.get(`/projects/${id}`)
        project = await api({
          method: "GET",
          url: `/account/user/projects/${id}`
        })
        if (project) {
          context.commit('project_loaded', project)
        }
      }
    },
    updateProject: async function(context, options) {
      await api({
        method: "POST",
        url: `/account/user/projects/${options.project.id}`,
        data: options.update
      })
    }
  },
}
